var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoTon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 80,
    fill: "none",
    viewBox: "0 0 288 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0098EA",
    d: "M107.797 63c12.427 0 22.5-10.074 22.5-22.5 0-12.428-10.073-22.5-22.5-22.5s-22.5 10.072-22.5 22.5c0 12.426 10.073 22.5 22.5 22.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M115.482 30.561h-15.37c-2.825 0-4.608 3.044-3.195 5.516l9.484 16.446a1.61 1.61 0 0 0 2.791 0l9.485-16.446c1.412-2.472-.37-5.516-3.195-5.516m-9.098 17.018-2.068-4.002-4.978-8.913a.895.895 0 0 1 .32-1.194.8.8 0 0 1 .437-.117h6.272zm9.854-12.915-4.977 8.913-2.069 4.002V33.37h6.29c.689-.016 1.093.724.756 1.295M144.641 52.792h4.911V35.673h6.777v-4.658h-18.481v4.658h6.777c.016 0 .016 17.12.016 17.12m23.476.37c6.188 0 11.25-5.061 11.25-11.25 0-6.188-5.062-11.25-11.25-11.25-6.222 0-11.25 5.062-11.25 11.25 0 6.189 5.028 11.25 11.25 11.25m0-4.725c-3.565 0-6.34-3.01-6.34-6.525 0-3.514 2.792-6.524 6.34-6.524 3.531 0 6.323 3.01 6.323 6.524s-2.792 6.525-6.323 6.525m33.632 4.355V31.015h-4.91v13.42l-10.578-13.42h-4.204v21.76h4.877V39.324l10.611 13.453h4.204z"
  })));
};
export default SvgLogoTon;